
import {defineComponent} from "vue";

export default defineComponent({
  props: {
    code: {type: String},
    amount: {type: [Number, String]},
  },
});
